// All 10 SEO-optimised course landing pages live here.
// Each entry drives a route + meta + content.

export const COURSES = [
    {
        slug: "sainik-school-coaching-pathankot",
        category: "Defence",
        short: "Sainik School Coaching",
        title: "Sainik School Coaching in Pathankot",
        h1: "Best Sainik School Coaching in Pathankot",
        metaTitle:
            "Best Sainik School Coaching in Pathankot | AISSEE Class 6 & 9 - Dacron Classes",
        metaDescription:
            "Top Sainik School coaching in Pathankot for AISSEE Class 6 & 9. Expert faculty, NTA-pattern mock tests, written + interview prep. Book a Free Demo Class today.",
        keywords:
            "Best Sainik School Coaching in Pathankot, AISSEE Coaching Pathankot, Sainik School Class 6 Coaching, Sainik School Class 9 Coaching",
        hero:
            "Crack AISSEE 2026 (Class 6 & Class 9) with Pathankot's most trusted Sainik School coaching - written, interview & medical prep, all under one roof.",
        image:
            "https://images.unsplash.com/photo-1763656446247-958969cc7235?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBhcm15JTIwYWNhZGVteSUyMGNhZGV0c3xlbnwwfHx8fDE3NzcyMDUyNjl8MA&ixlib=rb-4.1.0&q=85",
        benefits: [
            "AISSEE pattern-based daily practice for Maths, Intelligence, Language & GK",
            "Personal mentorship from ex-defence officers and senior educators",
            "Weekly full-length mock tests with detailed performance analytics",
            "Interview & medical screening preparation included",
            "Small batches of 20-25 students for personal attention",
            "Doubt-clearing sessions every evening, free for all enrolled students",
        ],
        examInfo: [
            { label: "Exam Name", value: "AISSEE - All India Sainik Schools Entrance Exam" },
            { label: "Conducted By", value: "National Testing Agency (NTA)" },
            { label: "Eligibility", value: "Class 5 (for Class 6 entry) / Class 8 (for Class 9 entry)" },
            { label: "Mode", value: "Offline (OMR-based) - Pen & Paper" },
            { label: "Subjects", value: "Maths, Intelligence, Language, General Knowledge, (Class 9 also: Science, Social Science)" },
            { label: "Selection", value: "Written + Medical + Interview" },
        ],
        faqs: [
            {
                q: "Which is the best Sainik School coaching in Pathankot?",
                a: "Dacron Classes is widely recognised as the best Sainik School coaching in Pathankot. We have a proven track record of selections in AISSEE Class 6 and Class 9 with structured prep covering written, interview and medical rounds.",
            },
            {
                q: "When should my child start Sainik School preparation?",
                a: "Ideally a child should start prep 12-18 months before the AISSEE exam. We accept students from Class 4 onwards for the Class 6 batch and Class 7 onwards for the Class 9 batch.",
            },
            {
                q: "Do you provide hostel or residential facility?",
                a: "We are a day-coaching institute in Pathankot. We offer extended study hours, evening doubt clinics, and weekend test series so students get residential-grade prep while staying with their family.",
            },
            {
                q: "What is the Sainik School entrance exam pattern?",
                a: "AISSEE for Class 6 covers Maths, Intelligence, Language and GK (300 marks). For Class 9 it adds Science and Social Science (400 marks). Selection is based on written, medical and interview rounds.",
            },
        ],
        related: ["nda-coaching-pathankot", "rms-coaching-pathankot", "rimc-coaching-pathankot"],
    },
    {
        slug: "nda-coaching-pathankot",
        category: "Defence",
        short: "NDA Coaching",
        title: "NDA Coaching in Pathankot",
        h1: "Best NDA Coaching in Pathankot",
        metaTitle:
            "Best NDA Coaching in Pathankot | UPSC NDA Written + SSB - Dacron Classes",
        metaDescription:
            "Join the best NDA coaching in Pathankot. UPSC NDA written prep (Maths + GAT), SSB interview training, ex-officer mentors. Free Demo Class - Book Now.",
        keywords:
            "Best NDA Coaching in Pathankot, NDA Coaching Pathankot, UPSC NDA Written Coaching, SSB Interview Coaching Pathankot",
        hero:
            "Train with serving and retired defence officers. End-to-end NDA prep - written, SSB interview, and physical fitness - in Pathankot.",
        image:
            "https://images.pexels.com/photos/34954631/pexels-photo-34954631.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        benefits: [
            "Complete UPSC NDA syllabus: Maths (300) + GAT (600) coverage",
            "5-day SSB interview workshop with PIQ, GTO, psychology & personal interview",
            "Officer-led mentorship from veterans of the Indian Armed Forces",
            "Bi-weekly mock tests modeled on the latest UPSC NDA pattern",
            "Personality development, current affairs and physical fitness guidance",
            "Crash courses for Class 12 students appearing in upcoming NDA",
        ],
        examInfo: [
            { label: "Exam Name", value: "NDA & NA Examination" },
            { label: "Conducted By", value: "Union Public Service Commission (UPSC)" },
            { label: "Eligibility", value: "12th passed (Maths + Physics for Air Force/Navy), Unmarried, Age 16.5-19.5 years" },
            { label: "Frequency", value: "Twice a year (NDA-I & NDA-II)" },
            { label: "Stages", value: "Written (900 marks) + SSB Interview (900 marks)" },
            { label: "Subjects", value: "Mathematics, General Ability Test (English + GK)" },
        ],
        faqs: [
            {
                q: "Which is the best NDA coaching in Pathankot?",
                a: "Dacron Classes runs Pathankot's most result-oriented NDA coaching programme - led by ex-defence officers and combining written prep with full SSB interview training.",
            },
            {
                q: "Can I prepare for NDA along with Class 11 and 12?",
                a: "Yes. We run integrated NDA + Class 11/12 batches so students can clear board exams and target NDA-1 (in Class 12) simultaneously without duplication of effort.",
            },
            {
                q: "Do you cover SSB interview?",
                a: "Absolutely. Our 5-day SSB workshop covers all stages - Screening (OIR & PPDT), Psychology tests, GTO tasks, Personal Interview and Conference - with mock boards and individual feedback.",
            },
            {
                q: "What is the NDA written exam pattern?",
                a: "Two papers: Mathematics (300 marks, 2.5 hrs) and General Ability Test (600 marks, 2.5 hrs). Negative marking of 1/3rd applies. Total 900 marks; SSB carries another 900.",
            },
        ],
        related: ["sainik-school-coaching-pathankot", "defence-exam-preparation-pathankot", "rimc-coaching-pathankot"],
    },
    {
        slug: "rms-coaching-pathankot",
        category: "Defence",
        short: "RMS Coaching",
        title: "RMS Coaching in Pathankot",
        h1: "Best RMS (Rashtriya Military School) Coaching in Pathankot",
        metaTitle:
            "Best RMS Coaching in Pathankot | Rashtriya Military School Class 6 & 9 - Dacron",
        metaDescription:
            "Top RMS coaching in Pathankot for Class 6 & 9 entry. Written + interview + medical prep with ex-officer mentors. Book a Free Demo today.",
        keywords:
            "Best RMS Coaching in Pathankot, Rashtriya Military School Coaching, RMS CET Coaching Pathankot",
        hero:
            "Get your child into a Rashtriya Military School with India's top defence coaching curriculum, available right here in Pathankot.",
        image:
            "https://images.unsplash.com/photo-1763656446247-958969cc7235?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBhcm15JTIwYWNhZGVteSUyMGNhZGV0c3xlbnwwfHx8fDE3NzcyMDUyNjl8MA&ixlib=rb-4.1.0&q=85",
        benefits: [
            "Targeted RMS CET pattern preparation for Class 6 and Class 9 entry",
            "Maths, English, Intelligence and GK with weekly diagnostic tests",
            "Interview and viva-voce coaching with mock panels",
            "Medical fitness guidance and posture training",
            "Small classroom batches with one-to-one mentor attention",
            "Customised study material aligned to the latest RMS syllabus",
        ],
        examInfo: [
            { label: "Exam Name", value: "RMS Common Entrance Test (CET)" },
            { label: "Conducted By", value: "Rashtriya Military Schools, Ministry of Defence" },
            { label: "Eligibility", value: "Class 5 passed (for Class 6) / Class 8 passed (for Class 9)" },
            { label: "Mode", value: "Offline written test" },
            { label: "Stages", value: "Written + Interview + Medical" },
            { label: "Schools", value: "RMS Chail, Ajmer, Belgaum, Bangalore, Dholpur" },
        ],
        faqs: [
            {
                q: "What is the difference between RMS and Sainik School?",
                a: "Both are residential schools that prepare students for defence careers. RMS (5 schools) is run by the Indian Army; Sainik Schools (33 schools) come under the Ministry of Defence's Sainik Schools Society. We coach for both.",
            },
            {
                q: "When does the RMS CET happen?",
                a: "RMS CET is typically held in December each year, with results in February-March. We start prep at least 9-12 months in advance.",
            },
            {
                q: "Is the interview tough for RMS?",
                a: "The interview tests confidence, communication, awareness and basic defence aptitude. Our mock panels and personality-development sessions prepare students thoroughly.",
            },
        ],
        related: ["sainik-school-coaching-pathankot", "rimc-coaching-pathankot", "defence-exam-preparation-pathankot"],
    },
    {
        slug: "rimc-coaching-pathankot",
        category: "Defence",
        short: "RIMC Coaching",
        title: "RIMC Coaching in Pathankot",
        h1: "Best RIMC Coaching in Pathankot",
        metaTitle:
            "Best RIMC Coaching in Pathankot | Rashtriya Indian Military College - Dacron",
        metaDescription:
            "Top RIMC coaching in Pathankot. Written, viva and interview prep for RIMC Dehradun entrance. Trusted by parents across Punjab.",
        keywords:
            "Best RIMC Coaching in Pathankot, RIMC Dehradun Coaching, RIMC Entrance Exam Coaching",
        hero:
            "Aim for India's most prestigious feeder institution - RIMC Dehradun. Structured prep for written + viva + interview, in Pathankot.",
        image:
            "https://images.pexels.com/photos/34954631/pexels-photo-34954631.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        benefits: [
            "Subject-wise prep for English, Maths and General Knowledge",
            "Comprehension, vocabulary and essay writing focus for high English weightage",
            "Mock viva-voce sessions with experienced interview panels",
            "Personality grooming and current affairs sessions",
            "Limited seats - one-on-one mentoring throughout the course",
        ],
        examInfo: [
            { label: "Exam Name", value: "RIMC Entrance Exam" },
            { label: "Conducted By", value: "Rashtriya Indian Military College, Dehradun" },
            { label: "Eligibility", value: "Boys & girls between 11.5 and 13 years (admission to Class 8)" },
            { label: "Frequency", value: "Twice a year (June & December)" },
            { label: "Stages", value: "Written (English, Maths, GK) + Viva + Medical" },
        ],
        faqs: [
            {
                q: "How competitive is the RIMC entrance?",
                a: "RIMC admits roughly 25 students twice a year, making it one of India's most competitive school entrance exams. Structured coaching and rigorous mock tests are essential.",
            },
            {
                q: "Do girls also get admission to RIMC?",
                a: "Yes, RIMC has been admitting girl cadets since 2021. We coach both boys and girls for the entrance exam and viva.",
            },
            {
                q: "What is the syllabus for RIMC?",
                a: "English (125 marks), Mathematics (200 marks) and General Knowledge (75 marks) - total 400 marks written, plus a viva for 50 marks.",
            },
        ],
        related: ["sainik-school-coaching-pathankot", "rms-coaching-pathankot", "nda-coaching-pathankot"],
    },
    {
        slug: "neet-coaching-pathankot",
        category: "Medical",
        short: "NEET Coaching",
        title: "NEET Coaching in Pathankot",
        h1: "Best NEET Coaching in Pathankot",
        metaTitle:
            "Best NEET Coaching in Pathankot | NEET UG Class 11, 12 & Droppers - Dacron",
        metaDescription:
            "Top NEET coaching in Pathankot for Class 11, 12 & droppers. NCERT-based teaching, daily practice, NTA pattern mocks. Book a Free Demo Class.",
        keywords:
            "Best NEET Coaching in Pathankot, NEET Coaching Pathankot, NEET UG Coaching Punjab, NEET Droppers Batch Pathankot",
        hero:
            "Join Pathankot's most outcome-driven NEET programme - NCERT-rooted teaching, daily DPPs, and full-length NTA mocks.",
        image:
            "https://images.unsplash.com/photo-1707944745899-104a4b12d945?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwZW5naW5lZXJpbmclMjBzdHVkZW50c3xlbnwwfHx8fDE3NzcyMDUyNjl8MA&ixlib=rb-4.1.0&q=85",
        benefits: [
            "Concept-first teaching anchored to NCERT - the foundation NEET demands",
            "Separate streams for Class 11, Class 12 and Droppers",
            "Daily Practice Problems (DPPs) and chapter-wise tests",
            "16+ full-length NEET mock tests with all-India ranking",
            "Personal mentor for academic and emotional support",
            "Doubt portal + recorded lectures for revision anytime",
        ],
        examInfo: [
            { label: "Exam Name", value: "NEET-UG (National Eligibility cum Entrance Test)" },
            { label: "Conducted By", value: "National Testing Agency (NTA)" },
            { label: "Eligibility", value: "12th with PCB - 50% (UR), 40% (SC/ST/OBC)" },
            { label: "Mode", value: "Offline (OMR-based)" },
            { label: "Subjects", value: "Physics (180), Chemistry (180), Biology (360)" },
            { label: "Total Marks", value: "720 marks - Negative marking applies" },
        ],
        faqs: [
            {
                q: "Which is the best NEET coaching in Pathankot?",
                a: "Dacron Classes is one of the highest-rated NEET coaching institutes in Pathankot - with a strong faculty in Physics, Chemistry and Biology and a structured 11-12-Dropper roadmap.",
            },
            {
                q: "Do you have a NEET Droppers batch?",
                a: "Yes. Our intensive Droppers batch focuses on full syllabus revision, weakness mapping and 30+ mock tests over the year.",
            },
            {
                q: "Is your NEET coaching NCERT-based?",
                a: "100%. We anchor every chapter to NCERT, then layer on advanced practice. NEET rewards NCERT mastery, and our results prove it.",
            },
            {
                q: "Can I take NEET coaching with school?",
                a: "Yes. Our morning/evening batches are designed around school timings so students don't miss any school work.",
            },
        ],
        related: ["jee-coaching-pathankot", "foundation-courses-pathankot", "class-6-to-12-coaching-pathankot"],
    },
    {
        slug: "jee-coaching-pathankot",
        category: "Engineering",
        short: "JEE Coaching",
        title: "JEE Coaching in Pathankot",
        h1: "Best JEE Coaching in Pathankot",
        metaTitle:
            "Best JEE Coaching in Pathankot | JEE Main + Advanced - Dacron Classes",
        metaDescription:
            "Crack JEE Main & Advanced with Pathankot's top coaching. IIT/NIT alumni faculty, weekly tests, doubt support. Free Demo Class - Book Now.",
        keywords:
            "Best JEE Coaching in Pathankot, JEE Main Coaching Pathankot, JEE Advanced Coaching Punjab, IIT Coaching Pathankot",
        hero:
            "From basics to JEE Advanced - everything you need to crack the IIT entrance, taught by IIT/NIT alumni right here in Pathankot.",
        image:
            "https://images.unsplash.com/photo-1731357266501-fc8594f84707?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwZW5naW5lZXJpbmclMjBzdHVkZW50c3xlbnwwfHx8fDE3NzcyMDUyNjl8MA&ixlib=rb-4.1.0&q=85",
        benefits: [
            "Integrated JEE Main + Advanced curriculum aligned to NTA & IIT pattern",
            "IIT/NIT alumni faculty for Physics, Chemistry & Maths",
            "Weekly tests + monthly mocks with detailed solutions and rank lists",
            "Olympiad and KVPY exposure for early advantage",
            "Recorded lectures, doubt forum and one-to-one mentor calls",
            "Separate batches for Class 11, Class 12 and Droppers",
        ],
        examInfo: [
            { label: "Exam Name", value: "JEE Main & JEE Advanced" },
            { label: "Conducted By", value: "NTA (Main) / IIT-Bombay/Delhi etc. (Advanced)" },
            { label: "Eligibility", value: "12th with PCM - 75% (UR) for IIT/NIT" },
            { label: "Mode", value: "Computer Based Test (CBT)" },
            { label: "Subjects", value: "Physics, Chemistry, Mathematics" },
            { label: "Attempts", value: "JEE Main twice a year; Advanced - top 2.5L candidates" },
        ],
        faqs: [
            {
                q: "Which is the best JEE coaching in Pathankot?",
                a: "Dacron Classes combines IIT/NIT alumni faculty with a proven micro-schedule for JEE Main and Advanced - making it Pathankot's first-choice JEE coaching.",
            },
            {
                q: "Do you offer integrated school + JEE programme?",
                a: "Yes. Our integrated programme covers CBSE/ICSE Class 11-12 board syllabus along with JEE prep, so students don't have to juggle two timetables.",
            },
            {
                q: "What faculty do you have for JEE?",
                a: "Our core faculty includes IIT and NIT alumni with 8-15 years of experience. They handle PCM concepts plus advanced problem-solving for JEE Advanced.",
            },
        ],
        related: ["neet-coaching-pathankot", "foundation-courses-pathankot", "class-6-to-12-coaching-pathankot"],
    },
    {
        slug: "best-tuition-centre-pathankot",
        category: "Tuition",
        short: "Best Tuition Centre",
        title: "Best Tuition Centre in Pathankot",
        h1: "Best Tuition Centre in Pathankot",
        metaTitle:
            "Best Tuition Centre in Pathankot | All Boards - CBSE, ICSE, PSEB - Dacron",
        metaDescription:
            "Pathankot's top tuition centre for Class 6 to 12 across CBSE, ICSE & PSEB boards. Maths, Science, English, SST. Book a Free Demo today.",
        keywords:
            "Best Tuition Centre in Pathankot, Top Tuition in Pathankot, CBSE Tuition Pathankot, ICSE Tuition Pathankot, PSEB Tuition",
        hero:
            "Personal attention, board-specific teaching, and rapid score improvement - the reason parents in Pathankot trust Dacron for tuitions.",
        image:
            "https://images.pexels.com/photos/33745700/pexels-photo-33745700.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        benefits: [
            "Specialised batches for CBSE, ICSE and PSEB boards",
            "All subjects: Maths, Science, English, SST, Hindi, Punjabi, Computer",
            "Class strength capped at 20 - true personal attention",
            "Pre-board mocks, sample paper practice, and answer-writing drills",
            "Parent-teacher reviews every month with progress reports",
            "Affordable monthly fees with sibling discounts",
        ],
        examInfo: [
            { label: "Boards Covered", value: "CBSE, ICSE/ISC, PSEB" },
            { label: "Classes", value: "6, 7, 8, 9, 10, 11, 12" },
            { label: "Subjects", value: "Maths, Science (Phy/Chem/Bio), English, SST, Computer, Hindi, Punjabi" },
            { label: "Modes", value: "Classroom + Hybrid (recorded lectures available)" },
        ],
        faqs: [
            {
                q: "Which is the best tuition centre in Pathankot?",
                a: "Parents across Pathankot rate Dacron Classes as the best tuition centre - thanks to small batch sizes, board-specific teaching and consistent grade improvements.",
            },
            {
                q: "Do you cover all boards?",
                a: "Yes - CBSE, ICSE/ISC and Punjab Board (PSEB) are all covered with separate batches and board-specific question banks.",
            },
            {
                q: "What are your tuition fees?",
                a: "Fees vary by class and number of subjects. We offer transparent monthly plans with sibling and early-bird discounts. Please call us for a fee chart.",
            },
        ],
        related: ["class-6-to-12-coaching-pathankot", "foundation-courses-pathankot", "neet-coaching-pathankot"],
    },
    {
        slug: "class-6-to-12-coaching-pathankot",
        category: "Tuition",
        short: "Class 6-12 Coaching",
        title: "Class 6 to 12 Coaching in Pathankot",
        h1: "Best Class 6 to 12 Coaching in Pathankot",
        metaTitle:
            "Class 6 to 12 Coaching in Pathankot | School + Competitive Prep - Dacron",
        metaDescription:
            "Class 6-12 coaching in Pathankot covering CBSE, ICSE, PSEB syllabus + foundation for NTSE, Olympiads, NEET, JEE. Book a Free Demo.",
        keywords:
            "Class 6 to 12 Coaching Pathankot, School Coaching Pathankot, Tuition Class 9 10 Pathankot, Tuition Class 11 12 Pathankot",
        hero:
            "One curriculum, every grade. Strong school marks plus competitive-exam readiness - all in a single coaching journey.",
        image:
            "https://images.pexels.com/photos/33745700/pexels-photo-33745700.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        benefits: [
            "Class-wise specialised faculty across all subjects",
            "Foundation track from Class 6 - NTSE, Olympiad, Sainik & NEET/JEE early prep",
            "Detailed performance reports shared with parents every month",
            "Grade improvement guarantee with periodic assessments",
            "Hybrid mode - classroom + recorded backup lectures",
        ],
        examInfo: [
            { label: "Classes", value: "Class 6, 7, 8, 9, 10, 11, 12" },
            { label: "Streams", value: "Science (PCM/PCB), Commerce, Humanities" },
            { label: "Boards", value: "CBSE, ICSE/ISC, PSEB" },
            { label: "Add-ons", value: "Olympiad, NTSE, KVPY, Foundation NEET/JEE" },
        ],
        faqs: [
            {
                q: "Do you cover board prep and entrance prep together?",
                a: "Yes. Our integrated programme aligns school syllabus with foundation for NTSE, Olympiads, NEET, JEE and defence exams - no time wasted on overlap.",
            },
            {
                q: "Is there a Class 10 board crash course?",
                a: "Absolutely. Our 60-day Class 10 board crash course covers all subjects with daily mock tests and answer-writing practice.",
            },
            {
                q: "Do you take students from any school?",
                a: "Yes. Our students come from every major school in Pathankot - CBSE, ICSE and PSEB boards welcome.",
            },
        ],
        related: ["best-tuition-centre-pathankot", "foundation-courses-pathankot", "neet-coaching-pathankot"],
    },
    {
        slug: "foundation-courses-pathankot",
        category: "Foundation",
        short: "Foundation Courses",
        title: "Foundation Courses in Pathankot",
        h1: "Foundation Courses for Class 6-10 in Pathankot",
        metaTitle:
            "Foundation Courses in Pathankot | NEET, JEE, NTSE, Sainik School - Dacron",
        metaDescription:
            "Build a strong foundation early. Class 6-10 foundation programme in Pathankot for NEET, JEE, NTSE, Olympiads, Sainik School & NDA prep.",
        keywords:
            "Foundation Courses Pathankot, NEET Foundation Pathankot, JEE Foundation Pathankot, NTSE Coaching Pathankot, Olympiad Coaching",
        hero:
            "Start early. Win bigger. Our Foundation programme builds Maths, Science and reasoning muscle from Class 6 onwards.",
        image:
            "https://images.pexels.com/photos/33745700/pexels-photo-33745700.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        benefits: [
            "Concept-deep curriculum aligned with NEET/JEE/Sainik/NTSE patterns",
            "Maths Olympiad and Science Olympiad inclusion at no extra cost",
            "Logical reasoning and aptitude as a separate weekly subject",
            "Annual NTSE prep track for Class 9-10 students",
            "Habits of self-study, time-table and revision systems built early",
        ],
        examInfo: [
            { label: "Classes", value: "Class 6, 7, 8, 9, 10" },
            { label: "Streams", value: "NEET Foundation / JEE Foundation / Sainik & NDA Foundation" },
            { label: "Add-ons", value: "Olympiads (NSO, IMO, IEO), NTSE, KVPY" },
            { label: "Duration", value: "Annual + 6-month accelerator options" },
        ],
        faqs: [
            {
                q: "What age is right for foundation classes?",
                a: "Foundation can begin as early as Class 6. The earlier the start, the deeper the conceptual base for NEET, JEE, NDA and Sainik exams.",
            },
            {
                q: "Will it overload my child?",
                a: "No - foundation classes are designed as 4-6 hours/week and replace the need for separate tuition + competitive prep. We protect your child's free time.",
            },
            {
                q: "Do you prepare for NTSE and Olympiads too?",
                a: "Yes. NTSE and Olympiad prep are baked into the foundation curriculum at no extra fee.",
            },
        ],
        related: ["neet-coaching-pathankot", "jee-coaching-pathankot", "sainik-school-coaching-pathankot"],
    },
    {
        slug: "defence-exam-preparation-pathankot",
        category: "Defence",
        short: "Defence Exam Prep",
        title: "Defence Exam Preparation in Pathankot",
        h1: "Best Defence Coaching Institute in Pathankot",
        metaTitle:
            "Best Defence Coaching Institute in Pathankot | NDA, CDS, AFCAT, Sainik - Dacron",
        metaDescription:
            "Pathankot's most trusted defence coaching - NDA, CDS, AFCAT, Sainik, RIMC, RMS, Agniveer, SSB. Ex-officer mentors. Book a Free Demo Class.",
        keywords:
            "Best Defence Coaching Institute in Pathankot, Defence Coaching Pathankot, CDS Coaching Pathankot, AFCAT Coaching, Agniveer Coaching",
        hero:
            "Wear the uniform with pride. End-to-end coaching for every defence entry - written, SSB and physical - in Pathankot.",
        image:
            "https://images.unsplash.com/photo-1763656446247-958969cc7235?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBhcm15JTIwYWNhZGVteSUyMGNhZGV0c3xlbnwwfHx8fDE3NzcyMDUyNjl8MA&ixlib=rb-4.1.0&q=85",
        benefits: [
            "Coverage of every entry - NDA, CDS, AFCAT, Sainik, RIMC, RMS, Agniveer",
            "5-day SSB workshop included with every long-term batch",
            "Physical fitness sessions every week with army-style drills",
            "Current affairs, GS and English communication built into the schedule",
            "Mentorship from veteran officers and TGCs of the Indian Army",
        ],
        examInfo: [
            { label: "Exams Covered", value: "NDA, CDS, AFCAT, Agniveer (Army/Navy/Air Force), Sainik, RIMC, RMS" },
            { label: "Stages", value: "Written + SSB + Medical + Physical" },
            { label: "Eligibility", value: "Varies by entry - 10th, 12th, Graduate" },
        ],
        faqs: [
            {
                q: "Which is the best defence coaching institute in Pathankot?",
                a: "Dacron Classes leads Pathankot's defence-coaching landscape with a one-stop programme covering written exams, SSB interviews and physical training.",
            },
            {
                q: "Do you train for Agniveer too?",
                a: "Yes. We have dedicated Agniveer batches for Army, Navy and Air Force - written prep + physical fitness + medical guidance.",
            },
            {
                q: "Can a graduate join CDS coaching here?",
                a: "Yes. Our CDS batch covers English, GK and Mathematics with weekly mocks plus full SSB interview prep.",
            },
        ],
        related: ["nda-coaching-pathankot", "sainik-school-coaching-pathankot", "rimc-coaching-pathankot"],
    },
];

export const COURSE_BY_SLUG = Object.fromEntries(COURSES.map((c) => [c.slug, c]));

export const PRIMARY_COURSES = COURSES.slice(0, 6);
